import React from "react";
import { Note, Pill, useLoad } from "../ui";

export function SourceViewer({ sourceKey, selected, onPick }: { sourceKey: string; selected?: string; onPick?: (proposalKey: string) => void }) {
  const { data, error } = useLoad<any>(`/sources/${sourceKey}/text`);
  if (error) return <div className="emptyline" data-testid="source-viewer-error">Source text not available to your role.</div>;
  if (!data) return <div className="skeleton" style={{ margin: 16 }} />;
  const text: string | null = data.text;
  const spans = (data.spans || []).filter((s: any) => s.supported && s.span).sort((a: any, b: any) => a.span.start - b.span.start);
  const parts: React.ReactNode[] = [];
  if (text != null) {
    let cur = 0;
    for (const s of spans) {
      if (s.span.start < cur) continue;
      if (s.span.start > cur) parts.push(<span key={`t${cur}`}>{text.slice(cur, s.span.start)}</span>);
      parts.push(<mark key={s.proposal_key} className={`cite ${s.proposal_key === selected ? "on" : ""} ${s.status}`} tabIndex={0} role="button" aria-label={`Citation for proposal ${s.proposal_key}`}
                       onClick={() => onPick?.(s.proposal_key)} onKeyDown={(e) => e.key === "Enter" && onPick?.(s.proposal_key)} data-testid={`cite-${s.proposal_key}`}>{text.slice(s.span.start, s.span.end)}</mark>);
      cur = s.span.end;
    }
    parts.push(<span key="tail">{text.slice(cur)}</span>);
  }
  const unsupported = (data.spans || []).filter((s: any) => !s.supported);
  const selSpan = (data.spans || []).find((s: any) => s.proposal_key === selected);
  return (
    <div className="docwrap" data-testid="source-document">
      <div className="docpage">
        <div className="docmeta"><span>{data.title} · {data.revision_label || `r${data.revision}`} · {data.origin}</span><Pill s={data.status} /></div>
        {selSpan && <p className="tiny muted" data-testid="citation-ref">Citation: {selSpan.span ? `line ${selSpan.span.line}, chars ${selSpan.span.start}-${selSpan.span.end}, source revision ${selSpan.span.source_revision}` : "no exact span"}{selSpan.supported ? "" : `: ${selSpan.limitation}`}</p>}
        {text == null ? <Note kind="red">{data.limitation}</Note> : <pre className="doctext" data-testid="source-text">{parts}</pre>}
        {unsupported.length ? <Note kind="warn" testid="citation-limitation">{unsupported.length} proposal(s) have no exact located span; their extracted excerpt is shown in the list but not highlighted here. Nothing is invented.</Note> : null}
        <p className="tiny muted">{data.limitation}</p>
      </div>
    </div>
  );
}
